import React, { useEffect, useState } from 'react';
import { Colors } from 'library';
import { Grid, useMediaQuery } from '@mui/material';
import HomeHeaderImage from 'assets/images/marketing-site/marketing-kids.webp';
import theme from 'theme';
import { client, consoleLogInDev, track } from 'shared';
import { FindButtons } from './FindButtons';
import { HomeFindSection } from './HomeFindSection';
import { StaffNearYou } from './StaffNearYou';
import { useHistory } from 'react-router';
import useQueryParams from 'shared/QueryParamsHook';
import { ITeacher } from 'models/Providers/Teacher';
import { StaffFilterOptions, defaultFilters } from './StaffFilter';

interface SpotlightWorkersResponse {
    workers: ITeacher[];
    vetted_workers_count: number;
}

export function HomeHeader({ signUp }: { signUp: () => void }) {
    const smDown = useMediaQuery(theme.breakpoints.down('md'));
    const history = useHistory();
    const query = useQueryParams();
    const searchedZipCode = query.get('zip');
    const queryFilters = query.get('filters');

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [zipCode, setZipCode] = useState<string>(query.get('zip') || '');
    const [spotlightWorkers, setSpotlightWorkers] = useState<ITeacher[]>([]);
    const [vettedWorkersCount, setVettedWorkersCount] = useState<number>(100);
    const [filters, setFilters] = useState<StaffFilterOptions>(
        queryFilters ? JSON.parse(atob(queryFilters)) : defaultFilters,
    );
    useEffect(() => {
        if (!searchedZipCode) {
            return;
        }
        setIsLoading(true);
        setSpotlightWorkers([]);
        setVettedWorkersCount(100);
        client(
            `api/contact-info-location/spotlighted-workers-by-location/?zip_code=${zipCode}${getEncodedFiltersQueryString(filters)}`,
        )
            .then((response: SpotlightWorkersResponse) => {
                setSpotlightWorkers(response.workers);
                setVettedWorkersCount(response.vetted_workers_count);
            })
            .catch(consoleLogInDev)
            .finally(() => {
                setIsLoading(false);
            });
    }, [searchedZipCode, queryFilters]);

    function updateZipCode(event: React.ChangeEvent<HTMLInputElement>) {
        if (event.target.value.length <= 5 && !isNaN(Number(event.target.value))) {
            setZipCode(event.target.value.trim());
            setFilters(defaultFilters);
        }
    }

    function getEncodedFiltersQueryString(filters: StaffFilterOptions) {
        return filters.education || filters.experience ? `&filters=${btoa(JSON.stringify(filters))}` : '';
    }

    function onSearch(newFilters: StaffFilterOptions) {
        setFilters(newFilters);
        const url = `/worker-search?zip=${zipCode}${getEncodedFiltersQueryString(newFilters)}`;
        history.push(url);
        track('Customer Searched for Staff Near Them');
    }

    return (
        <Grid
            container
            style={{
                backgroundImage: `url(${HomeHeaderImage})`,
                backgroundSize: smDown ? 'contain' : 'cover',
                paddingLeft: smDown ? 40 : 80,
                paddingRight: smDown ? 40 : 80,
                backgroundRepeat: 'no-repeat',
                backgroundPositionX: 'center',
            }}
        >
            {!searchedZipCode ? (
                <Grid container item justifyContent="space-between" style={{ marginBottom: '15% ' }}>
                    <Grid item container xs={12} md={6} flexDirection="column" style={{ marginTop: '15%' }}></Grid>
                    <Grid
                        item
                        container
                        xs={12}
                        md={5}
                        flexDirection="column"
                        style={{
                            marginTop: '15%',
                            backgroundColor: Colors.white,
                            borderRadius: 18,
                            border: `1px solid ${Colors.mediumGrey}`,
                            height: 'max-content',
                            padding: '30px 20px 30px 20px',
                            width: '60%',
                            marginBottom: smDown ? '15%' : 0,
                        }}
                    >
                        <FindButtons />
                        <HomeFindSection zipCode={zipCode} updateZipCode={updateZipCode} onSearch={onSearch} />
                    </Grid>
                </Grid>
            ) : (
                <StaffNearYou
                    signUp={signUp}
                    zipCode={zipCode}
                    searchedZipCode={searchedZipCode}
                    updateZipCode={updateZipCode}
                    onSearch={onSearch}
                    loading={isLoading}
                    workers={spotlightWorkers}
                    vettedWorkersCount={vettedWorkersCount}
                    filters={filters}
                />
            )}
        </Grid>
    );
}
